import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';
import logo from '../Assets/images/logo.jpg';

const About = () => {
  return (
    <div className="about-container">
      
      <header className="navbar">
        <div className="top-bar">
          <span>📍 Juffair - Bahrain</span>
          <span>📧 support@limoxyworld.com</span>
          <span>⏰ 24/7 Available</span>
        </div>
        <div className="main-nav">
          <div className="logo-container">
            <img src={logo} alt="Limoxy Logo" className="logo-image" />
            <span className="logo-text">LIMOXY</span>
          </div>
          <nav>
            <a href="/">Home</a>
            <a href="/about">About Us</a>
            <a href="/services">Our Services</a>
            <a href="/contact">Contact</a>
            <a href="/partner">Partner</a>
          </nav>
          <Link to="/Bookride">
                        <button className="book-btn">Book Your Ride</button>
                    </Link>
        </div>
      </header>

     
      <section className="about-section">
        <div className="about-content">
          <h1>About Limoxy World</h1>
          <p>
            Limoxy World is more than just a transportation service—it's a symbol of luxury, trust, and professionalism. 
            We deliver world-class chauffeur-based services designed to elevate the travel experience of global clients.
          </p>
          <p>
            With a handpicked team of elite chauffeurs, meticulously maintained vehicles, and operations in over 45,000 cities worldwide,
            we provide a seamless, secure, and superior journey. Whether it's a business transfer, airport pickup, or luxury tour,
            Limoxy World sets the standard in ground transportation.
          </p>
          <p>
            Our mission is simple: redefine travel with elegance, precision, and care—from arrival to farewell.
          </p>
        </div>
      </section>

      
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-logo">
            <img src={logo} alt="Limoxy Logo" className="footer-logo-img" />
            <h3>Limoxy World</h3>
          </div>
          <p>Providing world-class chauffeur services in 45,000+ locations. Trust. Luxury. Experience.</p>
          <div className="footer-links">
            <a href="/">Home</a>
            <a href="/about">About</a>
            <a href="/services">Services</a>
            <a href="/contact">Contact</a>
            <a href="/partner">Partner</a>
          </div>
          <p className="footer-bottom">© {new Date().getFullYear()} Limoxy World. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default About;